import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AlertService, AuthService, UIService } from 'src/app/_services';
import { UserService } from 'src/app/_services/user.service';
import { ProjectService } from 'src/app/_services/project.service';

/** Read-only customer page with the customer's users and projects */
@Component({
    selector: 'app-customer-view',
    templateUrl: './customer-view.component.html',
    styleUrls: ['../partners/view/partner-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerViewComponent implements OnInit {
  customerId: string;
  /** the list row passed in navigation state; gone after a reload, when only the id is known */
  customer: any;
  details: [string, string][] = [];

  users: any[] = [];
  userCount = 0;
  projects: any[] = [];
  projectCount = 0;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private projectService: ProjectService,
    private alertService: AlertService,
    private UIService: UIService,
    public auth: AuthService,
  ) { }

  ngOnInit() {
    this.UIService.setTitle('View Customer');
    this.customerId = this.route.snapshot.paramMap.get('id');
    this.customer = history.state?.data?.customer;

    const c = this.customer || {};
    this.details = ([
      ['Customer UUID', this.customerId],
      ['Customer name', c.name],
      ['Email', c.email],
      ['Phone', c.phone],
      ['Country', c.country],
      ['Partner', c.partner?.name],
    ] as [string, string][]).filter(([, value]) => value);

    forkJoin({
      users: this.userService.getCustomerUsers(this.customerId),
      projects: this.projectService.getCustomerProjects(this.customerId),
    }).subscribe({
      next: ({ users, projects }) => {
        this.users = users.users;
        this.userCount = users.count ?? users.users.length;
        this.projects = projects.projects;
        this.projectCount = projects.count ?? projects.projects.length;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.alertService.error("Failed to load the customer's users and projects");
      },
    });
  }
}
